module.exports = __webpack_public_path__ + "static/media/11.Wall Chaser.8a990162.jpg";